<template>
  <div class="menu__buttons">
    <RouterLink
      v-for="page in pages"
      :key="page.name"
      :to="{name: page.name}"
      class="menu-items"
    >
      <AuButton
        :icon="page.icon"
        :active="getIsActive(page)"
        :hovered-bg-color="adaptive ? '' : hovered"
        :active-color="adaptive ? '' : active"
        border-color="none"
        font-size="16px"
        width="100%"
        class="distance"
        @click="handleClose"
      >
        <span :class="{'menu-items': !adaptive}">
          {{ $t(page.title) }}
        </span>
      </AuButton>
    </RouterLink>

    <a
      v-if="showBlockScan"
      href="https://blockscan.rwapo.com"
      target="_blank"
      class="menu-items"
    >
      <AuButton
        icon="blockscan"
        :hovered-bg-color="adaptive ? '' : hovered"
        border-color="none"
        font-size="16px"
        width="100%"
        class="distance"
        @click="handleClose"
      >
        <span :class="{'menu-items': !adaptive}">
          BlockScan
        </span>
      </AuButton>
    </a>
  </div>
</template>

<script>
import _ from "lodash";
import isUserRole from "@/help/isUserRole";
import { checkAccess, scope } from "@/help/accessData";
import { mapGetters } from "vuex";
export default {
  props: {
    adaptive: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters({
      isLightTheme: "isLightTheme",
      profile: "profile/profile",
      language: "language"
    }),

    showBlockScan() {
      return process.env.VUE_APP_SHOW_BLOCKSCAN === "true" && checkAccess(scope.notRwa);
    },

    pages() {
      let menuItems = [
        { name: "dashboard", icon: "grid_round_green", title: this.$t("router.pages.dashboard") },
        { name: "my assets", icon: "bag_green", title: this.$t("router.pages.briefcase") },
        { name: "projects", icon: "projectsc", title: this.$t("router.pages.project") },
        { name: "transactions", icon: "swap_vertical_green", title: this.$t("router.pages.transactions") }
      ];

      if (isUserRole() === "issuer") {
        menuItems = [
          { name: "dashboard", icon: "grid_round_green", title: this.$t("router.pages.dashboard") },
          { name: "my assets", icon: "bag_green", title: this.$t("router.pages.briefcase") },
          { name: "my projects", icon: "folder", title: this.$t("router.pages.projects") },
          { name: "companies", icon: "company", title: this.$t("router.pages.companies") },
          { name: "news", icon: "news_glasses", title: this.$t("router.pages.news") },
          { name: "projects", icon: "projectsc", title: this.$t("router.pages.project") },
          { name: "transactions", icon: "swap_vertical_green", title: this.$t("router.pages.transactions") }
        ];

        if (this.isTestRole) {
          menuItems.push(menuItems[4]);
          menuItems[4] = { name: "my platforms", icon: "folder", title: this.$t("router.pages.myPlatforms") };
        }
      }

      if (this.isTestRole) {
        menuItems.splice(1, 0, { name: "it parks", icon: "bag_green", title: "IT-Parks" });
      }

      if (Object.values(this.profile?.roles).includes("ROLE_EXPERT")) {
        menuItems = [
          { name: "dashboard", icon: "grid_round_green", title: this.$t("router.pages.dashboard") }
        ];
      }
      if (this.buyToken) {
        menuItems.push({ name: "buyAut", icon: "blockscan", title: this.$t("router.pages.buyToken") });
      }
      return menuItems;
    },

    buyToken() {
      return checkAccess(scope.notAutentic) && checkAccess(scope.notRwa);
    },

    hovered() {
      return this.isLightTheme ? "#1F3A43" : "#28282d";
    },

    active() {
      return this.isLightTheme ? "#1F3A43A3" : "#28282dA3";
    },

    isTestRole() {
      return checkAccess(scope.testRole);
    }
  },
  mounted() {
    setTimeout(() => {
      document.addEventListener("click", this.handleClickOutside);
    }, 1);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },

  methods: {
    getIsActive(page) {
      return _.some(this.$route.matched, x => x.name == page.name || x.meta.parent == page.name);
    },

    handleClose() {
      this.$emit("close");
    },

    handleClickOutside() {
      this.$emit("close");
    }
  }
};
</script>

<style scoped lang="scss">
.menu__buttons {
  display: flex;
  flex-direction: column;
}
.menu-items {
  color: white;
}
.distance {
  margin: 2px 0;
}
</style>